import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BETelecommunicationCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Telecommunication Engineering",
    shortName: "B.E. Telecommunication",
    duration: "4 Years",
    description: "Explore the B.E. Telecommunication Engineering program, covering communication systems, networks, and signal processing.",
    overview: "Bachelor of Engineering in Telecommunication Engineering is a 4-year undergraduate program focused on communication systems, networks, signal processing, wireless and optical communications, and telecom protocols. The course prepares students for careers in telecom, networking, and research.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Valid entrance exam score (JEE Main/State CET)",
      "Interest in communication technology"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Basic Electronics",
          "Engineering Graphics",
          "Introduction to Telecommunication"
        ]
      },
      {
        year: 2,
        subjects: [
          "Signals and Systems",
          "Digital Electronics",
          "Network Analysis",
          "Electromagnetic Fields",
          "Analog Communication",
          "Microprocessors"
        ]
      },
      {
        year: 3,
        subjects: [
          "Wireless Communication",
          "Optical Fiber Communication",
          "Telecommunication Switching Systems",
          "Digital Signal Processing",
          "Mobile Networks",
          "Telecom Protocols"
        ]
      },
      {
        year: 4,
        subjects: [
          "Satellite Communication",
          "Telecom Management",
          "Internship/Project Work",
          "Advanced Networking",
          "Research Seminar"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Telecom Engineer",
        "Network Architect",
        "RF Engineer",
        "Telecom Consultant",
        "System Designer",
        "Telecom Analyst",
        "Research Scientist"
      ],
      industries: [
        "Telecom Companies",
        "Networking Firms",
        "Mobile Operators",
        "Research Organizations",
        "Government Agencies"
      ],
      averageSalary: "₹3-7 LPA (Fresher), ₹10-20 LPA (Experienced)",
      topRecruiters: [
        "BSNL",
        "Airtel",
        "Jio",
        "Ericsson",
        "Cisco",
        "Nokia",
        "ISRO"
      ]
    },
    admissionProcess: [
      "JEE Main/State CET",
      "Counseling and seat allocation",
      "Direct admission based on 12th marks (in some colleges)"
    ],
    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "IIT Madras",
        location: "Chennai",
        fees: "₹8,00,000",
        ranking: "NIRF Ranking: 1"
      },
      {
        name: "NIT Trichy",
        location: "Trichy",
        fees: "₹5,00,000",
        ranking: "NIRF Ranking: 8"
      }
    ],
    skills: [
      "Network Design",
      "Signal Processing",
      "Wireless Communication",
      "Telecom Protocols",
      "Project Management",
      "Data Analysis",
      "Communication Skills"
    ],
    futureScope: "Growing demand in 5G, IoT, satellite communication, and telecom infrastructure. Opportunities in research, government, and private sectors.",
    faqs: [
      {
        question: "What is the scope of Telecommunication Engineering?",
        answer: "Telecommunication engineers are in demand for designing, maintaining, and upgrading communication networks, especially with the growth of 5G and IoT."
      },
      {
        question: "Can I work abroad after this course?",
        answer: "Yes, telecom engineers are needed globally, especially in countries investing in new communication technologies."
      },
      {
        question: "Is coding required?",
        answer: "Basic programming knowledge is helpful, especially for network protocols and embedded systems."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BETelecommunicationCoursePage;
